// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"4375324c5c60e5608967","307":"140be8e5d8a81104caa0"}[chunkId] + ".js";
};